import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect () {
    super.connect();
    resetPage();
    initTimepicker();
  }

  parseFormDataToNestedObject(formData) {
    const data = {};

    formData.forEach((value, key) => {
      // Check for nested keys like "hour[date]"
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const parent = match[1];
        const child = match[2];
        data[parent] = data[parent] || {};
        data[parent][child] = value;
      } else {
        data[key] = value;
      }
    });

    return data;
  }

  updateFields() {
    const form = this.element.closest('form');
    const formData = new FormData(form);
    const data = this.parseFormDataToNestedObject(formData);
    const hourId = this.element.dataset.hourId;
    if (hourId) {
      data.id = hourId;
    }

    console.log("Updating fields with data:", data);

    fetch("/app/hours/update_fields_for_new", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.head.querySelector("[name='csrf-token']").content
      },
      credentials: "same-origin",
      body: JSON.stringify(data)
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          throw new Error("Failed to update date");
        }
      })
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => console.error(error));
  }
}
